$(() => {
  const { clearAllBodyScrollLocks } = window.bodyScrollLock;
  // !!! IMPORTANT !!!
  // IF YOU CHANGE THIS FUNCTION YOU MUST CHANGE THE SAME CLEAR FORM FUNCTION IN app/views/reviews/create.js.erb
  // THE MODAL IS REPEATED OVER THERE BECAUSE WE ONLY WANT TO CLEAR THE FORM IF THE REVIEW IS SUCCESSFUL ON SUBMIT
  const clearForm = () => {
    clearAllBodyScrollLocks();
    $('body').css('overflow', '');
    // Reset form inputs
    document.getElementById('new_review').reset();
    // Form reset doesn't reset rating value
    $('#review_rating').val('');
    // Clears preview images
    $('.modal-images-preview-wrapper.new-review').html('');
    // Reset rating title
    $('#new-review-rating-title').html('0 Stars');
    // Reset star classes
    Array.from($('.star.selected')).forEach(star =>
      $(star).removeClass('selected')
    );
    // Removes any image inputs
    Array.from($('input.review-image')).forEach(input => $(input).remove());
    // Removes any leftover error fields
    Array.from($('#new_review span.error')).forEach(error => {
      $(error.previousElementSibling).css('border-color', '#E5E5E5');
      $(error).remove();
    });

    window.history.pushState(null, null, `${window.location.pathname}`);
  };

  // Clear form on modal close
  $('#new-review-close').click(clearForm);

  // New Review Rating
  const starList = Array.from($('#new-review-stars .star'));

  const handleColorFill = (starSVG, event) => {
    if (event === 'mouseover') {
      $(starSVG).addClass('hovered');
    } else if (event === 'mouseleave') {
      $(starSVG).removeClass('hovered');
    } else if (event === 'click') {
      $(starSVG).addClass('selected');
    }
  };

  const handleRating = (jstar, event) => {
    const starClassList = jstar[0].classList.value;

    if (starClassList.includes('star 1')) {
      $('#new-review-rating-title').html('1 Star');
      starList.forEach((starSVG, index) => {
        if (index <= 0) {
          handleColorFill(starSVG, event);
        }
      });
    } else if (starClassList.includes('star 2')) {
      $('#new-review-rating-title').html('2 Stars');
      starList.forEach((starSVG, index) => {
        if (index <= 1) {
          handleColorFill(starSVG, event);
        }
      });
    } else if (starClassList.includes('star 3')) {
      $('#new-review-rating-title').html('3 Stars');
      starList.forEach((starSVG, index) => {
        if (index <= 2) {
          handleColorFill(starSVG, event);
        }
      });
    } else if (starClassList.includes('star 4')) {
      $('#new-review-rating-title').html('4 Stars');
      starList.forEach((starSVG, index) => {
        if (index <= 3) {
          handleColorFill(starSVG, event);
        }
      });
    } else if (starClassList.includes('star 5')) {
      $('#new-review-rating-title').html('5 Stars');
      starList.forEach((starSVG, index) => {
        if (index <= 4) {
          handleColorFill(starSVG, event);
        }
      });
    }
  };

  starList.forEach((star, index) => {
    const jstar = $(star); // Jquery node of star
    jstar.mouseover(() => {
      handleRating(jstar, 'mouseover');
    });

    jstar.mouseleave(() => {
      handleRating(jstar, 'mouseleave');
      if ($('svg.selected').length) {
        $('#new-review-rating-title').html(`${$('svg.selected').length} Stars`);
      } else {
        $('#new-review-rating-title').html('0 Stars');
      }
    });

    jstar.click(() => {
      // Clear selected class
      Array.from($('svg.selected')).forEach(svg => {
        $(svg).removeClass('selected');
      });
      handleRating(jstar, 'click');
      $('input.hidden#review_rating').val(() => index + 1);
    });
  });

  // Review submit
  // Clear form after submitting
  $('#new_review').bind('ajax:success', clearForm);
  // Clear form on modal close
  $('#new-review-close').click(clearForm);
});
